var map = {
	"./config/config.json": 7174,
	"./modules/InfoScreens/components/EventRow/translations/de.json": 8355,
	"./modules/InfoScreens/components/EventRow/translations/default.json": 87785,
	"./modules/InfoScreens/components/EventRow/translations/en.json": 59499,
	"./modules/InfoScreens/components/EventRow/translations/fr.json": 86928,
	"./modules/InfoScreens/components/EventRow/translations/hr.json": 42210,
	"./modules/InfoScreens/components/EventRow/translations/tr.json": 45518,
	"./modules/InfoScreens/components/Header/translations/de.json": 45346,
	"./modules/InfoScreens/components/Header/translations/default.json": 14982,
	"./modules/InfoScreens/components/Header/translations/en.json": 88970,
	"./modules/InfoScreens/components/Header/translations/fr.json": 50625,
	"./modules/InfoScreens/components/Header/translations/hr.json": 195,
	"./modules/InfoScreens/components/Header/translations/tr.json": 66015,
	"./modules/InfoScreens/containers/__mockJson__/events.json": 74754,
	"./modules/InfoScreens/containers/__mockJson__/eventsNormalized.json": 30843,
	"./modules/InfoTerminal/components/translations/de.json": 16685,
	"./modules/InfoTerminal/components/translations/default.json": 89971,
	"./modules/InfoTerminal/components/translations/en.json": 98785,
	"./modules/common/ErrorReporting/translations/de.json": 96782,
	"./modules/common/ErrorReporting/translations/default.json": 38666,
	"./modules/common/ErrorReporting/translations/en.json": 68374,
	"./modules/common/ErrorReporting/translations/fr.json": 28485,
	"./modules/common/ErrorReporting/translations/hr.json": 52511,
	"./modules/common/ErrorReporting/translations/tr.json": 78819,
	"./services/__mock__/bundesliga.json": 62993,
	"./services/__mock__/events1.json": 75787,
	"./services/__mock__/events10.json": 74253,
	"./services/__mock__/events2.json": 21114,
	"./services/__mock__/events3.json": 95493,
	"./services/__mock__/events4.json": 84548,
	"./services/__mock__/events5.json": 33591,
	"./services/__mock__/events6.json": 18902,
	"./services/__mock__/events7.json": 9937,
	"./services/__mock__/events8.json": 20944,
	"./services/__mock__/events9.json": 61491,
	"./services/__mock__/eventsMT1.json": 43536,
	"./services/__mock__/eventsMT10.json": 63224,
	"./services/__mock__/eventsMT11.json": 30971,
	"./services/__mock__/eventsMT2.json": 99053,
	"./services/__mock__/eventsMT3.json": 59618,
	"./services/__mock__/eventsMT4.json": 81663,
	"./services/__mock__/eventsMT5.json": 28172,
	"./services/__mock__/eventsMT6.json": 62169,
	"./services/__mock__/eventsMT7.json": 57982,
	"./services/__mock__/eventsMT8.json": 81771,
	"./services/__mock__/eventsMT9.json": 80360,
	"./services/__mock__/sectionScore.json": 36790
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51806;